const MK_MONTHS = [
  "јануари",
  "февруари",
  "март",
  "април",
  "мај",
  "јуни",
  "јули",
  "август",
  "септември",
  "октомври",
  "ноември",
  "декември",
];

const MK_WEEKDAYS = [
  "Недела",
  "Понеделник",
  "Вторник",
  "Среда",
  "Четврток",
  "Петок",
  "Сабота",
];

export const formatMkPrimaryDate = (date) => {
  if (!date) return null;
  return `${date.getDate()} ${MK_MONTHS[date.getMonth()]} ${date.getFullYear()}`;
};

export const formatMkFullDate = (date) => {
  if (!date) return null;
  return `${MK_WEEKDAYS[date.getDay()]}, ${date.getDate()} ${
    MK_MONTHS[date.getMonth()]
  }, ${date.getFullYear()}`;
};

export const formatMkTime = (date) => {
  if (!date) return null;
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  return `${hh}:${mm}ч`;
};
